import React, {Component} from 'react';
import axios from 'axios';
import { store } from 'react-notifications-component';
import * as ReactBootStrap from 'react-bootstrap';
import EstadoVacio from '../components/EstadoVacio';
import '../tools/css/HistoriasClinicasConfiguradas.css';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL = process.env.REACT_APP_API_URL;

class HistoriasClinicasConfiguradas extends Component {

  constructor(){
    super();
    this.state = {
      loading: true,
      historias: [],
      historiaSeleccionada: null,
      desactivando: false
    };
  }

  componentDidMount(){
    this.listarHistorias();
  }

  listarHistorias(){
    this.setState({ loading:true });

    axios.get(ApiURL + "/api/ConfigClinicalHistory/ListAll")
    .then((response) => {
      console.log(response);
      const historias = (response.data && response.data.data) || response.data || [];
      this.setState({ historias, loading:false });
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading:false });
    });
  }

  editarHistoria = (historia) => {
    window.location.href = "/config_historia_clinica?id=" + historia.id;
  };

  abrirConfirmarDesactivar = (historia) => {
    this.setState({ historiaSeleccionada: historia }, () => {
      $('#modal-desactivar-historia').modal('show');
    });
  };

  desactivarHistoria = () => {
    const { historiaSeleccionada } = this.state;
    if(!historiaSeleccionada) return;

    this.setState({ desactivando:true });

    axios.put(ApiURL + "/api/ConfigClinicalHistory/" + historiaSeleccionada.id + "/Toggle")
    .then((response) => {
      console.log(response);
      store.addNotification({
        title:'Muy bien',
        message:"Historia clínica desactivada correctamente",
        type:'success',
        container:'top-right',
        animationIn:["animated", "fadeIn"],
        animationOut:["animated", "fadeOut"],
        dismiss:{ duration:8000, showIcon:true }
      });
      this.setState({ desactivando:false, historiaSeleccionada:null });
      $('#modal-desactivar-historia').modal('hide');
      this.listarHistorias();
    })
    .catch((error) => {
      console.log(error);
      const mensaje = (error.response && error.response.data && error.response.data.message) || "No se pudo desactivar la historia clínica";
      store.addNotification({
        title:'Atención',
        message: mensaje,
        type:'danger',
        container:'top-right',
        animationIn:["animated", "fadeIn"],
        animationOut:["animated", "fadeOut"],
        dismiss:{ duration:10000, showIcon:true }
      });
      this.setState({ desactivando:false });
    });
  };

  render(){
    const { historias, loading, historiaSeleccionada } = this.state;

    return (

      <div className="content-wrapper">

        <div className="col-12 col-sm-12">

          <div className="hcc-header">
            <div className="hcc-header__icono"><i className="fas fa-file-medical-alt"></i></div>
            <div className="hcc-header__texto">
              <h1 className="hcc-header__titulo">Editar configuración de historias clínicas</h1>
              <p className="hcc-header__subtitulo">Estas son las historias clínicas que has configurado. Elige una para editarla o desactivarla.</p>
            </div>
          </div>

          <div className="card hcc-card">
            <div className="card-body">

              <div className="d-flex justify-content-center">
                {loading ? <ReactBootStrap.Spinner animation="border" /> : false}
              </div>

              {(!loading && historias.length===0) ? (
                <div className="hcc-empty">
                  <div className="d-flex justify-content-center"><EstadoVacio/></div>
                  <div className="d-flex justify-content-center"><h5><b>Todavía no has configurado ninguna historia clínica</b></h5></div>
                </div>
              ) : null}

              {historias.length>0 ? (
                <div className="hcc-table-wrap">
                  <table className="table table-bordered table-striped hcc-table">
                    <thead>
                      <tr>
                        <th>ID Historia</th>
                        <th>Nombre</th>
                        <th>Especialidad</th>
                        <th>Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historias.map((historia) => (
                        <tr key={historia.id}>
                          <td>{historia.id}</td>
                          <td>{historia.name}</td>
                          <td>{historia.specialtyName}</td>
                          <td className="text-center hcc-td-opciones">
                            <div className="dropdown">
                              <button type="button" className="btn hcc-btn-opciones dropdown-toggle" id={"hccOpciones" + historia.id} data-toggle="dropdown" data-boundary="window" aria-haspopup="true" aria-expanded="false" title="Opciones">
                                <i className="fas fa-ellipsis-v"></i>
                              </button>
                              <div className="dropdown-menu dropdown-menu-right" aria-labelledby={"hccOpciones" + historia.id}>
                                <a className="dropdown-item" href="#" onClick={(e)=>{e.preventDefault(); this.editarHistoria(historia)}}>
                                  <i className="fas fa-pen text-primary mr-2"></i> Editar configuración
                                </a>
                                <a className="dropdown-item" href="#" onClick={(e)=>{e.preventDefault(); this.abrirConfirmarDesactivar(historia)}}>
                                  <i className="fas fa-ban text-danger mr-2"></i> Desactivar historia clínica
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : null}

            </div>
          </div>

        </div>

        <div className="modal fade" id="modal-desactivar-historia" data-backdrop="static">
          <div className="modal-dialog modal-sm modal-dialog-centered">
            <div className="modal-content hcc-desactivar-modal">
              <div className="modal-header hcc-desactivar-modal__header">
                <button type="button" className="close hcc-desactivar-modal__close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <div className="hcc-desactivar-modal__icono"><i className="fas fa-exclamation-triangle"></i></div>
                <h4 className="modal-title hcc-desactivar-modal__title">Desactivar historia clínica</h4>
              </div>
              <div className="modal-body hcc-desactivar-modal__body">
                <p className="hcc-desactivar-modal__texto">
                  Vas a desactivar <b>{historiaSeleccionada ? historiaSeleccionada.name : 'esta historia clínica'}</b>. Tus profesionales dejarán de verla disponible para nuevas consultas.
                </p>
                <p className="hcc-desactivar-modal__pregunta">¿Deseas continuar?</p>
              </div>
              <div className="modal-footer justify-content-between hcc-desactivar-modal__footer">
                <button type="button" className="btn hcc-desactivar-modal__btn-cancelar" data-dismiss="modal">No, mantener</button>
                <button type="button" className="btn hcc-desactivar-modal__btn-desactivar" disabled={this.state.desactivando} onClick={this.desactivarHistoria}>
                  {this.state.desactivando ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-ban"></i>} Sí, desactivar
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>

    );
  }

}

export default HistoriasClinicasConfiguradas;
